import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Link } from 'react-router-dom';
import styles from './Header.module.css';
import Avatar from '../../img/avatar.png';
import { FiMenu } from 'react-icons/fi';
import { clearTeamSession, refreshTeamAccess, teamCan } from '../Helper/teamAccess';

function Header() {
    const navigate = useNavigate();
    const location = useLocation();
    const [open, setOpen] = useState(false);
    const [, setTick] = useState(0);

    // the owner may have changed this member's permissions since login
    useEffect(() => {
        refreshTeamAccess().then((me) => me && setTick((n) => n + 1));
    }, []);

    const logoutHandler = () => {
        localStorage.removeItem('token');
        localStorage.removeItem('id');
        localStorage.removeItem('role');
        clearTeamSession();
        setOpen(false);
    };

    const link = (to, label) => (
        <Link to={to} style={{ textDecoration: 'none' }} onClick={() => setOpen(false)}>
            <li style={location.pathname === to ? { fontWeight: 700 } : undefined}>{label}</li>
        </Link>
    );

    return (
        <div className={styles['main-header']}>
            <div className={styles['mobile-container']}>
                <div className={styles.logo}>
                    <Link style={{ textDecoration: 'none' }} onClick={() => navigate(0)}>
                        <div className={styles['logo-text']}>Call Center</div>
                    </Link>
                </div>
                <div className={styles['menu-icon']} onClick={() => setOpen(!open)}>
                    <FiMenu style={{ fontSize: '24px' }} />
                </div>
            </div>
            <div className={`${styles.nav} ${open ? styles.active : ''}`}>
                <ul>
                    {link('/team-order', 'Orders')}
                    {teamCan('returns') && link('/team-returns', 'Returns')}
                    <Link to="/teamlogin" style={{ textDecoration: 'none' }} onClick={logoutHandler}>
                        <li>Logout</li>
                    </Link>
                </ul>
                <div className={styles.avatar}>
                    <img src={Avatar} height={40} width={40} alt="Avatar" />
                </div>
            </div>
        </div>
    );
}

export default Header;
